import { IconBook, IconCalendarWeek, IconChartBar, IconList } from '@tabler/icons-react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const EmptyContent = ({
  icon,
  text,
  classes = '',
  style = null
}) => {
  const iconSize = 40;
  return /*#__PURE__*/_jsxs("div", {
    className: `flex flex-col items-center justify-center gap-4 p-6 rounded-xl ${classes}`,
    style: {
      ...style
    },
    children: [icon === 'calendar' ? /*#__PURE__*/_jsx(IconCalendarWeek, {
      size: iconSize,
      color: "var(--gray-70)"
    }) : icon === 'book' ? /*#__PURE__*/_jsx(IconBook, {
      size: iconSize,
      color: "var(--gray-70)"
    }) : icon === 'chartBar' ? /*#__PURE__*/_jsx(IconChartBar, {
      size: iconSize,
      color: "var(--gray-70)"
    }) : /*#__PURE__*/_jsx(IconList, {
      size: iconSize,
      color: "var(--gray-70)"
    }), /*#__PURE__*/_jsx("p", {
      className: "text-center whitespace-pre-line text-body-md-500 text-my-gray-50",
      children: text
    })]
  });
};
export default EmptyContent;